import Page from '../page';



export default class ContactManager extends Page {
	constructor() {
		super();
	}
	init() {

	}
	scroll() {

	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}